import React, { useState } from 'react';
import 'moment/locale/pt';
import { Box, Button, Typography } from '@mui/material';
import { grey } from '@mui/material/colors';
import { enqueueSnackbar } from 'notistack';
import { DeleteFetch, PutFetch } from '../../../../services/apiBase'
import axios from 'axios';

export default function RemoveModal({ agreement, onClose, getList, table }) {
  const [load, setLoad] = useState(false);

  const handleOnCloseModal = () => {
    onClose();
  }

  const handleRemoveItem = async (e) => {
    setLoad(true);
    try {
      //const response = await axios.delete(`http://localhost:4600/financial/indicators?indicator=${table}`, {data: { id: agreement.id }});
      const response = await DeleteFetch(`/financial/indicators?indicator=${table}`, {data: { id: agreement.id }});
      getList();
      handleOnCloseModal();
      enqueueSnackbar('Remoção salva com sucesso!', { variant: 'success' });
      
    return;
    } catch (error) {
     console.log(error);
    } finally {
      setLoad(false);
    }
  }

  return (
    <Box sx={{
      position: 'absolute',
      top: '50%',
      left: '50%',
      transform: 'translate(-50%, -50%)',
      boxShadow: 24,
      borderRadius: 2,
      backgroundColor: grey[300]
    }}>
      <Box sx={{
        padding: '16px',
        borderRadius: '8px 8px 0 0',
        backgroundColor: '#fff'
      }}>
        <Typography variant="h6" component="h2">
          Remover indicador
        </Typography>
      </Box>

      <Box sx={{
        marginTop: '16px',
        marginBottom: '16px',
        marginRight: '32px',
        width: 400,
        minWidth: 400,
        maxHeight: '80%',
        height: '90%',
        width: '100%',
        backgroundColor: '#fff',
        borderRadius: 1,
        display: 'flex',
        flexDirection: 'column',
        padding: 2,
        gap: 2
      }}>
        
        Deseja realmente deletar este indicador?
        
      </Box>

      <Box sx={{
        display: 'flex',
        width: '100%',
        justifyContent: 'flex-end',
        gap: 1,
        padding: 2,
        borderRadius: '0 0 8px 8px',
        backgroundColor: '#fff'
      }}>
        <Button variant="contained" color={'success'}>
          <Typography color={'#fff'} onClick={() => handleRemoveItem()}>
            Remover
          </Typography>
        </Button>
        <Button variant="contained" color='error' onClick={onClose}>
          <Typography color={'#fff'}>
            Fechar
          </Typography>
        </Button>
      </Box>
    </Box>
  )
}
